import { render, staticRenderFns } from "./FilesDownload.vue?vue&type=template&id=9a341de6"
import script from "./FilesDownload.ts?vue&type=script&lang=ts&external"
export * from "./FilesDownload.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports